<ng-template #notificationTemplate let-notification>
  <div class="ant-notification-notice-content">
    <div class="ant-notification-notice-with-icon">
      <span class="ant-notification-notice-icon"><i nz-icon nzType="appstore-add" style="color: rgb(16, 142, 233)"></i></span>
      <div class="ant-notification-notice-message" i18n>A new version of the application is available. Click Install to update it.</div>
      <div class="ant-notification-notice-description" style="color: #cb3939" i18n>Note: if you have work in progress, save it first, so you don't lose anything.</div>
    </div>
    <span class="ant-notification-notice-btn">
      <button nz-button nzType="primary" nzSize="small" (click)="installAppNewVersion()">
        <span i18n>Install</span>
      </button>
    </span>
  </div>
</ng-template>
<div *ngIf="loading && authenticatorService.authStatus === 'authenticated'" style="width: 100vw; padding: 7rem; position: absolute">
  <div class="fx-row fx-justify-center">
    <img src="assets/img/tol-spinner.gif" alt="loading" />
  </div>
</div>
<div *ngIf="authenticatorService.authStatus !== 'authenticated'" style="height: 100vh" class="w-100 fx-row fx-justify-center fx-items-center">
  <amplify-authenticator [services]="services" initialState="signIn" [hideSignUp]="true" [formFields]="formFields">
    <ng-template amplifySlot="sign-in-header">
      <h2 class="amplify-heading" style="padding: var(--amplify-space-xl) 0 0 var(--amplify-space-xl); font-size: medium; font-weight: bold" i18n>Welcome, please sign in your account</h2>
    </ng-template>
    <ng-template amplifySlot="footer">
      <div *ngIf="biometricEnable" style="padding: var(--amplify-space-xl); text-align: center">
        <button nz-button nzType="primary" nzGhost nzSize="large" [nzSize]="'default'" (click)="biometricLogin()">
          <strong><i class="mr-05" nz-icon nzType="login"></i>Use biometric ID</strong>
        </button>
      </div>
      <div *ngIf="!biometricEnable" style="padding: var(--amplify-space-xl); text-align: center">
        <h4 i18n>Tip: you can activate biometric ID in the app to accelerate logins</h4>
      </div>
    </ng-template>
  </amplify-authenticator>
</div>
<nz-layout class="app-layout" *ngIf="authenticatorService.authStatus === 'authenticated' && !loading">
  <nz-sider
    class="menu-sidebar"
    *ngIf="{ syncing: offlineApiService.syncing$ | async, tasksCountInterval: tasksCountObservable$ | async, tasksCountForToday: (tasksCountForToday$ | async) ?? 0 } as vm"
    nzCollapsible
    [nzCollapsedWidth]="0"
    nzWidth="250px"
    nzBreakpoint="lg"
    [(nzCollapsed)]="apiService.isMenuCollapse"
    [nzTrigger]="null"
  >
    <div class="sidebar-logo">
      <a routerLink="/welcome">
        <img class="logo" src="assets/icons/icon-72x72.png" alt="logo" />
        <h1>TreesOfLives</h1>
      </a>
    </div>
    <ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="apiService.isMenuCollapse">
      <li *ngIf="hasHomeMenu" nz-submenu nzOpen nzTitle="Home" i18n-nzTitle nzIcon="home">
        <ul>
          <li nz-menu-item nzMatchRouter>
            <a (click)="redirectTo($event, '/welcome')" routerLink="/welcome" i18n>Welcome</a>
          </li>
          <li *ngIf="hasScheduleMenu" nz-menu-item nzMatchRouter [nzDisabled]="!apiService.onLine">
            <a (click)="redirectTo($event, '/schedule')" routerLink="/schedule" i18n>Schedule </a>
            <nz-badge *ngIf="eventsCount > 0 || vm.tasksCountForToday > 0" [nzCount]="eventsCount + vm.tasksCountForToday" class="pl-05" [nzStyle]="{ backgroundColor: '#f50' }"> </nz-badge>
          </li>
          <li
            *ngIf="hasMessagesMenu"
            nz-submenu
            [nzOpen]="newMessagesCount > 0 && apiService.isLargeScreen && !apiService.isMenuCollapse"
            nzTitle="Messages"
            i18n-nzTitle
            [nzDisabled]="!apiService.onLine"
          >
            <ul>
              <li nz-menu-item nzMatchRouter [nzDisabled]="!apiService.onLine">
                <a (click)="redirectTo($event, '/messages/inbox')" routerLink="/messages/inbox" i18n>Inbox </a>
                <nz-badge *ngIf="newMessagesCount > 0" [nzCount]="newMessagesCount" class="pl-05" [nzStyle]="{ backgroundColor: '#f50' }"> </nz-badge>
              </li>
              <li nz-menu-item nzMatchRouter [nzDisabled]="!apiService.onLine">
                <a i18n (click)="redirectTo($event, '/messages/sent-messages')" routerLink="/messages/sent-messages" routerLinkActive="sent-messages">Sent items</a>
              </li>
            </ul>
          </li>
          <li *ngIf="hasOfflineMenu" nz-menu-item nzMatchRouter>
            <a (click)="redirectTo($event, '/offline')" routerLink="/offline" i18n>Offline data</a>
            <span *ngIf="serviceWorkerActive" style="background-color: #108ee9; height: 4px; margin-left: 0.4rem">&nbsp;&nbsp;</span>
            &nbsp;<i nz-icon nzType="loading" *ngIf="vm.syncing"></i>
          </li>
        </ul>
      </li>
      <li *ngIf="hasProgramDataMenu" nz-submenu nzTitle="Operations" i18n-nzTitle nzIcon="project">
        <ul>
          <li nz-menu-item nzMatchRouter *ngIf="hasProgramsMenu" [nzDisabled]="!apiService.onLine">
            <a i18n (click)="redirectTo($event, '/programs')" routerLink="/programs">Programs</a>
          </li>
          <li nz-menu-item nzMatchRouter *ngIf="hasDashboardMenu">
            <a i18n (click)="redirectTo($event, '/dashboard')" routerLink="/dashboard">Dashboard</a>
          </li>
          <li nz-menu-item nzMatchRouter *ngIf="hasPropertiesMenu">
            <a i18n (click)="redirectTo($event, '/properties')" routerLink="/properties">Properties</a>
          </li>
          <li *ngIf="hasFormsMenu" nz-menu-item nzMatchRouter>
            <a i18n (click)="redirectTo($event, '/dynamic/form-list/field')" routerLink="/dynamic/form-list/field">Field Forms</a>
          </li>
          <li *ngIf="hasContactsMenu" nz-menu-item nzMatchRouter [nzDisabled]="!apiService.onLine">
            <a i18n (click)="redirectTo($event, '/contacts')" routerLink="/contacts">Contacts</a>
          </li>
          <li *ngIf="hasNewProgramMapMenu" nz-submenu nzTitle="Maps" i18n-nzTitle>
            <ul>
              <li nz-menu-item nzMatchRouter nzMatchRouterExact>
                <a i18n (click)="redirectTo($event, '/maps')" routerLink="/maps">Base Map</a>
              </li>
              <li nz-menu-item nzMatchRouter>
                <a i18n (click)="redirectTo($event, '/maps/proposition')" routerLink="/maps/proposition">Propositions</a>
              </li>
              <li *ngIf="hasInvestmentMapsMenu" nz-menu-item nzMatchRouter [nzDisabled]="!apiService.onLine">
                <a i18n (click)="redirectTo($event, '/maps/investment-projects')" routerLink="/maps/investment-projects">Investment Projects</a>
              </li>
            </ul>
          </li>
          <li *ngIf="hasFormsMenu" nz-menu-item nzMatchRouter [nzDisabled]="!apiService.onLine">
            <a i18n (click)="redirectTo($event, '/dynamic/form-list/piloting')" routerLink="/dynamic/form-list/piloting">Piloting Forms</a>
          </li>
          <li *ngIf="hasFormsMenu" nz-menu-item nzMatchRouter [nzDisabled]="!apiService.onLine">
            <a i18n (click)="redirectTo($event, '/dynamic/form-list/administrative')" routerLink="/dynamic/form-list/administrative">Administrative Forms</a>
          </li>
          <li *ngIf="hasReportsMenu" nz-menu-item nzMatchRouter [nzDisabled]="!apiService.onLine">
            <a i18n (click)="redirectTo($event, '/reports-list')" routerLink="/reports-list">Reports</a>
          </li>
          <li *ngIf="hasBusinessIntelligenceMenu" nz-menu-item nzMatchRouter [nzDisabled]="!apiService.onLine">
            <a i18n (click)="redirectTo($event, '/business-intelligences')" routerLink="/business-intelligences">Business Intelligence</a>
          </li>
        </ul>
      </li>
      <li *ngIf="hasFeedbackMenu" nz-submenu nzTitle="Field Feedback" i18n-nzTitle nzIcon="comment" [nzDisabled]="!apiService.onLine">
        <ul>
          <li *ngIf="hasMediasMenu" nz-menu-item nzMatchRouter>
            <a i18n (click)="redirectTo($event, '/medias')" routerLink="/medias">Medias</a>
          </li>
          <li *ngIf="hasNewsMenu" nz-menu-item nzMatchRouter>
            <a i18n (click)="redirectTo($event, '/news-list')" routerLink="/news-list">News</a>
          </li>
        </ul>
      </li>
      <li *ngIf="hasAccountingMenu" nz-submenu nzTitle="Accounting" i18n-nzTitle nzIcon="dollar" [nzDisabled]="!apiService.onLine">
        <ul>
          <li nz-menu-item nzMatchRouter [nzDisabled]="!apiService.onLine">
            <a (click)="redirectTo($event, '/invoices')" routerLink="/invoices" i18n>Disbursement Requests</a>
          </li>
        </ul>
      </li>
      <li nz-submenu nzTitle="Administration" i18n-nzTitle nzIcon="setting" *ngIf="hasAdministrationMenu" [nzDisabled]="!apiService.onLine">
        <ul>
          <li *ngIf="hasParametersMenu" nz-submenu nzTitle="Parameters" i18n-nzTitle>
            <ul>
              <li *ngIf="hasDomainValuesMenu" nz-menu-item nzMatchRouter>
                <a i18n (click)="redirectTo($event, '/domain-values')" routerLink="/domain-values">Domain Values</a>
              </li>
            </ul>
          </li>
          <li *ngIf="hasInvestmentProjectsMenu" nz-submenu nzTitle="Investments" i18n-nzTitle>
            <ul>
              <li *ngIf="hasInvestmentProjectsMenu" nz-menu-item nzMatchRouter>
                <a i18n (click)="redirectTo($event, '/investment-projects')" routerLink="/investment-projects">Investment Projects</a>
              </li>
            </ul>
            <ul>
              <li *ngIf="hasNotificationsMenu" nz-menu-item nzMatchRouter>
                <a i18n (click)="redirectTo($event, '/project-notifications')" routerLink="/project-notifications">Notifications</a>
              </li>
            </ul>
          </li>
          <li nz-menu-item nzMatchRouter *ngIf="hasFormBuilderMenu">
            <a i18n (click)="redirectTo($event, '/templates/form-definitions')" routerLink="/templates/form-definitions">Form Builder</a>
          </li>
          <li *ngIf="hasSecurityMenu" nz-submenu nzTitle="Security" i18n-nzTitle>
            <ul>
              <li nz-menu-item nzMatchRouter *ngIf="hasUsersMenu">
                <a i18n (click)="redirectTo($event, '/users')" routerLink="/users">Users</a>
              </li>
              <li nz-menu-item nzMatchRouter *ngIf="hasAccountRequestsMenu">
                <a i18n (click)="redirectTo($event, '/account-requests')" routerLink="/account-requests">Account requests</a>
              </li>
              <li nz-menu-item nzMatchRouter *ngIf="hasPermissionsMenu">
                <a i18n (click)="redirectTo($event, '/permissions')" routerLink="/permissions">Permissions</a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <li *ngIf="!biometricEnable && biometricActivated" nz-menu-item (click)="activateBiometric()"><i class="mr-05" nz-icon nzType="login"></i><span i18n>Activate Biometric</span></li>
      <li nz-menu-item (click)="utilitiesService.reloadApp()" [nzDisabled]="!apiService.onLine"><i class="mr-05" nz-icon nzType="reload"></i><span i18n>Reload</span></li>
      <li nz-menu-item (click)="signOut()" [nzDisabled]="!apiService.onLine"><i class="mr-05" nz-icon nzType="logout"></i><span i18n>Sign out</span></li>
    </ul>
    <div class="fx-col fx-justify-end fx-items-start">
      <div nz-typography nzType="success" class="ml-1 mt-1">
        <code>v{{ version }}</code>
      </div>
    </div>
  </nz-sider>
  <nz-layout [ngClass]="apiService.isMenuCollapse ? 'menu-collapsed' : 'menu-open'">
    <nz-header [ngClass]="envClass" *ngIf="{ callingAPI: apiService.callingAPI$ | async, notifications: notifications$ | async } as vm2">
      <div class="pl-05 fx-row fx-gap-1-rem fx-justify-start fx-items-center pr-1-lt-sm pr-15-gt-xs">
        <span class="header-trigger" (click)="toggleCollapse()">
          <i class="trigger" nz-icon [nzType]="apiService.isMenuCollapse ? 'menu-unfold' : 'menu-fold'"></i>
          &nbsp;&nbsp;
          <i nz-icon nzType="loading" *ngIf="vm2.callingAPI && router.url.toString().indexOf('/dynamic/dynamic-form/') === -1"></i>
        </span>
        <span class="fxFlex"></span>
        <div class="pointer" *ngIf="vm2.notifications?.length && apiService.onLine && !apiService.isSmallScreen && !apiService.isExtraSmallScreen">
          <i nz-icon nzType="bell" style="font-size: 20px; color: white" (click)="showNotifications()"></i>
          <nz-badge *ngIf="hasNewNotifications" [nzCount]="hasNewNotifications" [nzStyle]="{ backgroundColor: '#f50' }" (click)="showNotifications()"> </nz-badge>
        </div>
        <nz-modal [nzClosable]="false" [nzVisible]="notificationsVisible()" (close)="hideNotifications()">
          <div *nzModalTitle>
            <span class="font-large" i18n>Notifications</span>
          </div>
          <ng-container *nzModalContent>
            <div style="max-height: 50vh; overflow-y: scroll">
              <nz-list nzBordered>
                <nz-list-item class="fx-row fx-gap-05-rem" *ngFor="let notif of vm2.notifications" style="padding: 0.5rem">
                  <app-alert [type]="notif.level === 'success' ? 'success' : 'error'" style="min-width: 100%" [ngStyle]="{ border: notif.read ? '' : '2px solid black' }">
                    {{ notif.date | date: 'medium' : utilitiesService.locale.locale }}<br />
                    {{ notif.message | localizedLabel: 'value' }}
                  </app-alert>
                </nz-list-item>
              </nz-list>
            </div>
          </ng-container>
          <div *nzModalFooter>
            <button i18n nz-button nzType="default" (click)="hideNotifications()">Close</button>
          </div>
        </nz-modal>
        <div class="pointer">
          <i nz-icon nzType="mail" style="font-size: 20px; color: white" (click)="gotoMessages()"></i>
          <nz-badge *ngIf="newMessagesCount > 0" [ngClass]="!apiService.isMenuCollapse ? 'fx-hide-xs' : null" [nzCount]="newMessagesCount" [nzStyle]="{ backgroundColor: '#f50' }" (click)="gotoMessages()"> </nz-badge>
        </div>
        <div class="fx-row fx-gap-1-rem fx-justify-start fx-items-center" [ngClass]="!apiService.isMenuCollapse ? 'fx-hide-xs' : null">
          <div class="fx-hide-xs" style="color: white" *ngIf="apiService.isLargeScreen || apiService.isMenuCollapse">{{ apiService.user?.attributes?.email }}</div>
          <div *ngIf="!isPwaInstalled && apiService.onLine">
            <nz-radio-group [nzName]="'controlSize'" [nzSize]="'small'" [(ngModel)]="locale.locale" (ngModelChange)="switchLanguage()">
              <label nz-radio-button nzValue="fr"><span>fr</span></label>
              <label nz-radio-button nzValue="en"><span>en</span></label>
              <label nz-radio-button nzValue="es"><span>es</span></label>
            </nz-radio-group>
          </div>
          <!--<div>
            <button nz-button nzGhost nzType="primary" [nzSize]="'default'"
                  (click)="signOut()"><strong><i class="mr-05" nz-icon nzType="logout"></i>SIGN OUT</strong>
            </button>
          </div>-->
          <div>
            <i nz-icon nzType="wifi" style="font-size: 20px" [ngStyle]="{ color: apiService.onLine ? 'lightgreen' : 'red' }" (click)="showDrawer()"></i>
          </div>
        </div>
      </div>
    </nz-header>
    <nz-content id="inner-content">
      <div class="inner-content" [ngClass]="!apiService.isMenuCollapse ? 'fx-hide-xs' : null">
        <router-outlet name="modal"></router-outlet>
        <router-outlet></router-outlet>
      </div>
    </nz-content>
    <nz-drawer [nzVisible]="drawerVisible" nzPlacement="right" nzTitle="System" i18n-nzTitle nzWidth="350px" (nzOnClose)="closeDrawer()">
      <ng-container *nzDrawerContent>
        <p>
          <span i18n>Language:</span>&nbsp;<code>{{ navigatorProperties.language }}</code>
        </p>
        <p>
          <span i18n>User Agent:</span>&nbsp;<code>{{ navigatorProperties.userAgent }}</code>
        </p>
        <p>
          <span i18n>Vendor:</span>&nbsp;<code>{{ navigatorProperties.vendor }}</code>
        </p>
        <p>
          <span i18n>Storage quota:</span>&nbsp;<code>{{ (storageQuota / 1024 / 1000) | number : '1.0-2' }} Mb</code>
        </p>
        <p>
          <span i18n>Storage usage:</span>&nbsp;<code>{{ (storageUsage / 1024 / 1000) | number : '1.0-2' }} Mb</code>
        </p>
        <p>
          <button nz-button nzType="primary" nzGhost i18n nzSize="small" (click)="showConsole = true">Console</button>&nbsp;&nbsp;<button
            nz-button
            nzType="primary"
            nzGhost
            i18n
            nzSize="small"
            (click)="checkSentry()"
          >
            Check Sentry
          </button>
        </p>
        <nz-divider></nz-divider>
        <div *ngIf="apiService.networkInformation">
          <p i18n *ngIf="apiService.networkInformation?.type">
            Network type:&nbsp;<code>{{ apiService.networkInformation?.type }}</code>
          </p>
          <p i18n>
            Network effective type:&nbsp;<code>{{ apiService.networkInformation?.effectiveType }}</code>
          </p>
          <p i18n>
            Network speed:&nbsp;<code>{{ apiService.networkInformation?.downlink }}&nbsp;Mbps</code>
          </p>
          <p i18n>
            Round trip time:&nbsp;<code>{{ apiService.networkInformation?.rtt }}&nbsp;ms</code>
          </p>
          <p i18n>
            Save data mode:&nbsp;<code>{{ apiService.networkInformation?.saveData }}</code>
          </p>
        </div>
        <p>
          <span i18n>Memory:</span>&nbsp;<code>{{ memoryUsed }}/{{ memoryLimit }} Mb</code>
        </p>
        <div class="mt-1">
          <span i18n>Network speed test</span>&nbsp;&nbsp;<i nz-icon nzType="loading" *ngIf="networkSpeedInterval"></i>&nbsp;&nbsp;
          <button nz-button nzType="primary" nzSize="small" nzGhost i18n *ngIf="!networkSpeedInterval" (click)="startNetworkSpeedInterval()" [disabled]="!canSeeConsole">Start</button>
          <button nz-button nzType="primary" nzSize="small" nzGhost i18n *ngIf="networkSpeedInterval" nzLoading="false" (click)="stopNetworkSpeedInterval()">Stop</button>
          <p i18n class="ant-notification-notice-description mt-1" style="color: #cb3939">
            Warning, this feature is very demanding on the network. Do not let it run for long if you are using the mobile network.
          </p>
          <div *ngFor="let speed of networkSpeedValues; let i = index">
            <nz-progress [nzPercent]="(speed / 200) * 100" nzSize="small" [nzStatus]="i === 0 ? 'success' : 'normal'" [nzShowInfo]="false"></nz-progress>
            <code>{{ speed.toFixed(3) }} MBPS</code>
          </div>
        </div>
      </ng-container>
    </nz-drawer>
  </nz-layout>
</nz-layout>
<ng-container *ngIf="showConsole">
  <nz-modal [nzClosable]="false" [(nzVisible)]="showConsole" (close)="showConsole = false">
    <ng-container *nzModalContent>
      <textarea readonly [value]="logger.internalLogs | arrayToString" style="min-height: 400px" class="w-100"></textarea>
    </ng-container>
    <div *nzModalFooter>
      <button i18n nz-button nzType="default" (click)="showConsole = false">Close</button>
    </div>
  </nz-modal>
</ng-container>
